/* eslint-disable */

import { EQUITY_COLOR_MAP } from './EquityCapChart';

const EquityBreakdownTable = ({ equityCapData, hideTitle = false, hideCard = false }) => {
    // Format currency in Indian number system
    const formatIndianCurrency = (amount) => {
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
            maximumFractionDigits: 0,
        }).format(amount);
    };

    // Format percentage to 2 decimal places
    const formatPercentage = (percentage) => {
        return parseFloat(percentage).toFixed(2);
    };

    const rows = [
        { name: 'Large Cap', ...equityCapData.largeCap },
        { name: 'Mid Cap', ...equityCapData.midCap },
        { name: 'Small Cap', ...equityCapData.smallCap },
    ];

    // Calculate total
    const totalAmount = rows.reduce((sum, row) => sum + row.amount, 0);
    const totalPercentage = rows.reduce((sum, row) => sum + row.percentage, 0);

    const content = (
        <>
            {!hideTitle && (
                <div className="px-4 sm:px-6 py-3 sm:py-4 border-b border-gray-200">
                    <h2 className="text-base sm:text-lg">Equity Market Cap Breakdown</h2>
                </div>
            )}

            <div className="overflow-x-auto">
                <div className="rounded-lg border border-gray-200 overflow-hidden">
                    <table className="w-full">
                        <thead>
                            <tr className="bg-gray-50 border-b border-gray-200">
                                <th className="px-4 sm:px-6 py-3 text-left text-xs sm:text-sm text-gray-600">
                                    Asset Category
                                </th>
                                <th className="px-4 sm:px-6 py-3 text-right text-xs sm:text-sm text-gray-600">
                                    Amount
                                </th>
                                <th className="px-4 sm:px-6 py-3 text-right text-xs sm:text-sm text-gray-600 whitespace-nowrap">
                                    Share (%)
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows.map((row, index) => (
                                <tr
                                    key={row.name}
                                    className={`border-b border-gray-100 ${index % 2 === 0 ? 'bg-white' : 'bg-gray-50/50'
                                        }`}
                                >
                                    <td className="px-4 sm:px-6 py-3 sm:py-4 text-xs sm:text-sm text-gray-900">
                                        <div className="flex items-center gap-2">
                                            <div
                                                className="w-3 h-3 rounded-full flex-shrink-0"
                                                style={{ backgroundColor: EQUITY_COLOR_MAP[row.name] || '#6B7280' }}
                                            />
                                            <span>{row.name}</span>
                                        </div>
                                    </td>
                                    <td className="px-4 sm:px-6 py-3 sm:py-4 text-xs sm:text-sm text-gray-900 text-right tabular-nums">
                                        {formatIndianCurrency(row.amount)}
                                    </td>
                                    <td className="px-4 sm:px-6 py-3 sm:py-4 text-xs sm:text-sm text-gray-900 text-right tabular-nums">
                                        {formatPercentage(row.percentage)}%
                                    </td>
                                </tr>
                            ))}

                            {/* Total Row */}
                            <tr className="bg-teal-50 border-t-2 border-teal-200">
                                <td className="px-4 sm:px-6 py-3 sm:py-4 text-xs sm:text-sm text-gray-900">
                                    Total
                                </td>
                                <td className="px-4 sm:px-6 py-3 sm:py-4 text-xs sm:text-sm text-gray-900 text-right tabular-nums">
                                    {formatIndianCurrency(totalAmount)}
                                </td>
                                <td className="px-4 sm:px-6 py-3 sm:py-4 text-xs sm:text-sm text-teal-700 text-right tabular-nums">
                                    {formatPercentage(totalPercentage)}%
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );

    if (hideCard) {
        return content;
    }

    return (
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
            {content}
        </div>
    );
}

export default EquityBreakdownTable;